export default __webpack_public_path__ + "static/coffee-67e75e941f69490c192cb3fb3ffbe75a.svg";